import { render } from "./verifyEmailModal.vue?vue&type=template&id=4e00ef91&scoped=true"
import script from "./verifyEmailModal.vue?vue&type=script&lang=js"
export * from "./verifyEmailModal.vue?vue&type=script&lang=js"

import "./verifyEmailModal.vue?vue&type=style&index=0&id=4e00ef91&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e00ef91"]])

export default __exports__